<section class="banner">
	<div *ngFor="let newItem of listaBanner" (click)="fnIr(newItem)">
		<img [src]=" newItem.img " alt="{{ newItem.nombre }}" title="{{ newItem.nombre }}" loading="lazy">
	</div>
</section>